import { AnalyticsProvider } from '@anchorage/analytics';
import { getMixpanelOptions } from 'constants/app';
import { useAppContext } from 'context/AppContext/AppContext';
import type { ReactNode } from 'react';
import useIsPortoApp from 'utils/useIsPortoApp';

type Props = {
  children: ReactNode;
};
const AnalyticsWrapper = ({ children }: Props) => {
  const { sessionInfo } = useAppContext();
  const isPorto = useIsPortoApp();

  if (isPorto) {
    return <>{children}</>;
  }

  return (
    <AnalyticsProvider
      // we don't have info on the user so we identify users with the access token
      user={{ userKeyId: sessionInfo.access }}
      options={{ enabled: true, ...getMixpanelOptions() }}
    >
      {children}
    </AnalyticsProvider>
  );
};

export default AnalyticsWrapper;
